import axios from 'axios';
import {getDashboardStatsRoute} from '../apiRoutes';
import {DashboardStatsResponse} from '../apiContracts';

export const getDashboardStats = async (): Promise<DashboardStatsResponse> => {
    const result = DashboardStatsResponse.fromJS((await axios.get(getDashboardStatsRoute)).data);
    return result;
};
